<template>
  <div>
    <div class="row">
      <div class="col-md-4 col-sm-6 col-xs-6">
        <base-button
          @click="openModal"
          class="btn-dark float-sm-none float-md-left more-margin-top"
          >Modify</base-button
        >
      </div>

      <!-- Show Search Page "Search Order" Styling -->
      <div class="col-md-3 offset-md-5">
        <label for="searchBox">Search :</label>
        <el-input
          id="searchBox"
          type="search"
          class="mb-3 search-input"
          clearable
          prefix-icon="el-icon-search"
          placeholder="Search all Orders..."
          v-model="searchText"
          v-b-popover.hover.left="
            'Search results appear immediately upon typing.'
          "
        ></el-input>
      </div>
    </div>
    <div class="row">
      

      <el-table
        :data="getResults"
        :cell-style="tableRowClassName"
        :default-sort="{ prop: 'orderId', order: 'descending' }"
        aria-label="Order search results table"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column
          v-for="column in tableColumns"
          sortable
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="column.label"
        ></el-table-column>

        <el-table-column
          sortable
          prop="overdueForecast"
          label="Overdue / Delinquent"
          minWidth="220"
        >
          <template slot-scope="order">
            <span style="white-space: wrap;" v-html="order.row.overdueForecast"></span>
          </template>
        </el-table-column>
      </el-table>
      <b-modal
        ref="showModal"
        scrollable
        hide-footer
        hide-header
        no-close-on-backdrop
        size="lg"
        body-class="custom_alert_body"
      >
     
      <span>
        <span @click="closeModal" class="title title-up align-right">x</span>
        <h4  class="title title-up align-center">
          Modify Order
        </h4>
      </span>
    

      <hr />
        
        
        <div class="container">
          <base-input id="SelectRole">
            <treeselect
              v-model="assignedValue"
              class="select-primary"
              name="organization"
              :options="assignedOptions"
            />
          </base-input>
          <v-select v-if="assignedValue == this.LOGISTICS_TYPE_ID"
            id="LogisticsUser"
            v-model="assignedUserID"
            name="AssignedLogisticsUserDropdown"
            :reduce="(item) => item.id"
            label="name"
            :options="assignedLogisticsUserOptions"
            placeholder="Select"
          >
        </v-select>
        <v-select v-if="assignedValue == this.FINANCE_TYPE_ID"
            id="FinanceUser"
            v-model="assignedUserID"
            name="AssignedFinanceUserDropdown"
            :reduce="(item) => item.id"
            label="name"
            :options="assignedFinanceUserOptions"
            placeholder="Select"
          >
        </v-select>
          <v-select v-if="assignedValue == this.PARTNER_NATION_TYPE_ID"
            id="PartnerNationUser"
            v-model="assignedUserID"
            name="AssignedPartnerNationUserDropdown"
            :reduce="(item) => item.id"
            label="name"
            :options="assignedPartnerNationUsers"
            placeholder="Select"
          >
        </v-select>
        </div>

        <div class="alert_footer align-center">
          <base-button type="danger" @click="closeModal()" class="btn-danger">
           Close
          </base-button>
          <base-button class="btn float-right" @click="save()" type="primary">
            <i class="tim-icons icon-send"></i> Save
          </base-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>
  
  <script>
import axios from "@/axios";
import { Modal, BasePagination } from "@/components";
import { Table, TableColumn, Select, Option } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "@/util/util";
import swal from "sweetalert2";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BasePagination,
    Treeselect,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  name: "SearchAllOrdersReassignment",
  data: function () {
    return {
      selectedOrderId: 0,
      PARTNER_NATION_TYPE_ID: Util.PARTNER_NATION_TYPE_ID,
      FINANCE_TYPE_ID: Util.FINANCE_TYPE_ID,
      LOGISTICS_TYPE_ID: Util.LOGISTICS_TYPE_ID,
      organization: "",
      assignedValue: null,
      assignedUserID: "",
      assignedFinanceUser:"",
      assignedLogisticUser: "",
      assignedPartnerUser:"",
      agreedReturnDateLabel: "",
      deliveryStartDateLabel: "",
      deliveryEndDateLabel: "",
      tableColumns: [
        {
          prop: "orderId",
          label: "Order No.",
          minWidth: 140,
        },
        {
          prop: "requisitionNumber",
          label: "Requisition #",
          minWidth: 160,
        },
        {
          prop: "countryName",
          label: "Country",
          minWidth: 140,
        },
        {
          prop: "orderStatus",
          label: "status",
          minWidth: 120,
        },
        {
          prop: "totalLabel",
          label: "Total",
          minWidth: 150,
        },
        {
          prop: "paymentMethod",
          label: "Method of Payment",
          minWidth: 200,
        },
        {
          prop: "usBuySell",
          label: "Buy/Sell",
          minWidth: 130,
        },
        {
          prop: "assignedLogisticsUser",
          label: "Logistics",
          minWidth: 140,
        },
        {
          prop: "assignedFinanceUser",
          label: "Finance",
          minWidth: 130,
        },
        {
          prop: "assignedPartnerNationUser",
          label: "Partner Nation User",
          minWidth: 210,
        },
      ],
      excelLoadTime: 0,
      searchTimeOut: null,
      searchText: "",
      everythingShouldBeDisabled: true,
      multipleSelection: [],
    };
  },
  watch: {
    searchText(value) {
      clearTimeout(this.searchTimeOut);

      var self = this;
      let tempSearchCriteria = this.searchCriteria;
      tempSearchCriteria.SearchText = value;
      self.setSearchCriteria(tempSearchCriteria);
      self.searchTimeOut = setTimeout(function () {
        self.getSearchResultsReassignment();
      }, 1000);
    },

  },
  
  computed: {
    ...mapGetters({
      searchCriteria: "orders/searchCriteria",
      searchResultsReassignment: "orders/searchResultsReassignment",
      user: "users/user",
      assignedOptions: "orderUsers/orderUserTypes",
      assignedLogisticsUserOptions: "users/logisticsUsers",
      assignedFinanceUserOptions: "users/financeUsers",
      assignedPartnerNationUsers: "users/partnerNationUsers"
    }),
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    getServerResults() {
      if (!Util.isNullOrEmpty(this.searchCriteria)) {
        return this.searchResultsReassignment;
      } else {
        return [];
      }
    },
    getResultsPerPageOptions() {
      return Util.getInitialPaginationInfo().perPageOptions;
    },
    getCurrentPage() {
      return Util.isNullOrEmpty(this.getServerResults)
        ? 1
        : this.getServerResults.currentPage;
    },
    getResultsPerPage() {
      return Util.isNullOrEmpty(this.getServerResults)
        ? Util.getInitialPaginationInfo().perPage
        : this.getServerResults.pageSize;
    },
    getTotalNumberOfPages() {
      return Util.isNullOrEmpty(this.getServerResults)
        ? 1
        : this.getServerResults.pageCount;
    },
    getResults() {
      return Util.isNullOrEmpty(this.getServerResults)
        ? []
        : this.getServerResults;
      
    },
  },
  mounted() {
    this.getOrderUserTypes();
  },
  methods: {
    ...mapActions({
      getSearchResultsReassignment: "orders/getSearchResultsReassignment",
      setSearchCriteria: "orders/setSearchCriteria",
      getSearchExportResults: "orders/getSearchExportResults",
      getOrderUserTypes: "orderUsers/getOrderUserTypes",
      getOrdersBySearchFieldsToExcel: "orders/getOrdersBySearchFieldsToExcel",
    }),
    enableEverything() {
      // This is called in Search.vue
      this.everythingShouldBeDisabled = false;
    },
    handleNewSearch() {
      // This is called in Search.vue
      this.selectedPage = 1;
    },
    handleSelectionChange(val) {
      let ids = val.map(v => v.orderId);
      this.multipleSelection = ids;
    },
    disableEverything() {
      // This is called in Search.vue
      this.searchText = "";
      this.everythingShouldBeDisabled = true;
    },
    search(tempSearchCriteria) {
      this.setSearchCriteria(tempSearchCriteria);
      this.getSearchResultsReassignment();
    },
    showLoadingSweetAlert(message) {
      new swal({
        position: "top-end",
        icon: "warning",
        title: "Please Wait Patiently",
        html: message,
        timer: 10000,
        showConfirmButton: false,
      });
    },
    setExcelSearchCriteria() {
      let tempSearchCriteria = this.searchCriteria;
      tempSearchCriteria.IsExport = true;
      this.setSearchCriteria(tempSearchCriteria);
    },
    async exportToExcel() {
      this.excelLoadTime += 1;

      if (this.getServerResults.recordCount > 0) {
        this.setExcelSearchCriteria();
        this.getOrdersBySearchFieldsToExcel(this.searchCriteria).then(
          (result) => {
            this.excelLoadTime = 0;
          }
        );
      } else {
        data = [];
      }

      await new Promise((r) => setTimeout(r, 2000));
      if (this.excelLoadTime != 0) {
        this.showLoadingSweetAlert(
          "Your Excel document is loading.<br><br>This message will disappear automatically in 10 seconds."
        );
      }

      while (this.excelLoadTime != 0) {
        await new Promise((r) => setTimeout(r, 10000));
        if (this.excelLoadTime != 0) {
          this.showLoadingSweetAlert(
            'Please hang tight.  Your Excel document is <i>still loading</i>.<br><br><b>Note: <br>Depending on how many orders you export, it could take anywhere from a few seconds to over 5 minutes.</li><br><br><li>For exporting a large amount of orders, please consider "Create Report" (under Reports dropdown in navbar).'
          );
        }
      }
    },
    userIsAssigned(rowOrder) {
      if (
        !Util.isNullOrEmpty(rowOrder.logisticsUser) &&
        rowOrder.logisticsUser.id.toLowerCase() == this.user.id.toLowerCase()
      ) {
        return true;
      } else if (
        !Util.isNullOrEmpty(rowOrder.financeUser) &&
        rowOrder.financeUser.id.toLowerCase() == this.user.id.toLowerCase()
      ) {
        return true;
      } else {
        return false;
      }
    },
    tableRowClassName({ row, columnIndex }) {
      if (row.overdueForecast.includes("!") && columnIndex === 11) {
        return {
          // It is column 10 for overdue/delinquent highlighting.
          background: "#ffcece",
        };
      }
    },
    getOrderById(orderIdFromHtml) {
      return this.getResults.find((order) => order.orderId === orderIdFromHtml);
    },
    clickShowDetailsModal(orderIdFromHtml) {
      this.selectedOrderId = orderIdFromHtml;
      this.organization = this.getOrderById(orderIdFromHtml).organization;
      this.agreedReturnDateLabel =
        this.getOrderById(orderIdFromHtml).agreedReturnDateLabel;
      this.deliveryStartDateLabel =
        this.getOrderById(orderIdFromHtml).deliveryStartDateLabel;
      this.deliveryEndDateLabel =
        this.getOrderById(orderIdFromHtml).deliveryEndDateLabel;
      this.$refs.showDetailsModal.show();
    },
    clickCloseModal() {
      this.$refs.showDetailsModal.hide();
    },
    openModal() {
      this.$refs.showModal.show();
    },
    closeModal() {
      this.$refs.showModal.hide();
    },
    async save() {
      let dat = [];
      for(let i=0; i<this.multipleSelection.length; i++) {
        dat.push({
          orderId: this.multipleSelection[i],
          userTypeId: this.assignedValue,
          userId: this.assignedUserID,
          sendToAssigner: true,
          assignerNote: "Order Assigment",
        });
      }
      const options = {
        'Content-Type': 'application/json',
        config: {showToast: false}
      };

      if(dat.length === 0) {
        this.$toast.error("No order selected.");
        return;
      }
      try {
        let responsePost = await axios.post(`/api/orderusers/orders`, dat, options);
        this.$toast.success(responsePost.data);
        this.closeModal();
      } catch (err) {
        var message = err.response.data.message;
        this.$toast.error(message);
      }
    }
  },
};
</script>
  
  <style scoped>
.el-tooltip .btn-link .btn-warning .focusing {
  color: orange !important;
}

@media only screen and (max-width: 2038px) {
  .hide-if-large-screensize {
    display: none;
  }
}

@media only screen and (max-width: 800px) {
  .hide-if-medium-screensize {
    display: none;
  }
}
</style>